import { Btn, Container } from "./Ui";
import { MaskLines, Reveal } from "./Motion";
import { MARQUEE, CONTACT } from "../../data/content";
import { Download, Smartphone } from "lucide-react";

export const DownloadBand = () => (
  <section data-testid="app-download-section" className="bg-[#F4F7FB] py-16 lg:py-20">
    <Container>
      <Reveal className="flex flex-col items-start justify-between gap-8 rounded-[28px] border border-slate-200 bg-white p-8 shadow-[0_4px_20px_rgba(16,43,80,0.06)] sm:p-12 md:flex-row md:items-center">
        <div className="flex items-start gap-5">
          <span className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#102B50] text-white"><Smartphone className="h-6 w-6" /></span>
          <div>
            <span className="eyebrow">Downloads</span>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-[#102B50] sm:text-3xl">Get the app on your phone.</h2>
            <p className="mt-2 text-[15px] text-[#4A5D78]">One link that opens the right store for your Android or iOS device.</p>
          </div>
        </div>
        <Btn href={CONTACT.appDownload} target="_blank" rel="noopener noreferrer" arrow={false} data-testid="app-download-btn" className="w-full shrink-0 md:w-auto">
          <Download className="h-4 w-4" />Download App
        </Btn>
      </Reveal>
    </Container>
  </section>
);

export const PageHero = ({ eyebrow, lines, text, children, testid = "page-hero" }) => (
  <section data-testid={testid} className="relative overflow-hidden bg-white">
    <div className="grid-bg pointer-events-none absolute inset-0" />
    <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-[#2878E5]/15 blur-[120px]" />
    <Container className="relative pb-20 pt-16 sm:pt-24 lg:pb-28">
      <Reveal><span className="eyebrow">{eyebrow}</span></Reveal>
      <h1 className="mt-6 max-w-4xl font-display text-4xl font-extrabold leading-[1.06] tracking-tight text-[#102B50] sm:text-5xl lg:text-6xl">
        <MaskLines lines={lines} accentIndex={lines.length - 1} />
      </h1>
      {text && <Reveal delay={0.35}><p className="mt-7 max-w-2xl text-base leading-relaxed text-[#4A5D78] md:text-lg">{text}</p></Reveal>}
      {children && <Reveal delay={0.45} className="mt-9 flex flex-wrap gap-3">{children}</Reveal>}
    </Container>
  </section>
);

export const Marquee = () => (
  <div data-testid="capabilities-marquee" className="overflow-hidden border-y border-slate-200 bg-white py-6" aria-label="Capabilities">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {MARQUEE.map((m) => (
            <span key={m} className="flex items-center whitespace-nowrap px-8 font-display text-2xl font-semibold tracking-tight text-[#102B50]/80 sm:text-3xl">
              {m}
              <span className="ml-16 inline-block h-2 w-2 rotate-45 bg-[#D9A93F]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const CtaBand = ({ title = "Let’s Create Something That Performs.", text = "Tell us about your goals and we’ll come back with a partnership approach that fits.", primary = ["Start a Partnership", "/contact"], secondary = ["Contact Us", "/contact"] }) => (
  <section data-testid="final-cta" className="bg-white py-20 lg:py-28">
    <Container>
      <Reveal className="relative overflow-hidden rounded-[28px] bg-[#102B50] px-6 py-16 sm:px-12 lg:px-20 lg:py-24">
        <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#2878E5]/40 blur-[110px]" />
        <div className="pointer-events-none absolute -bottom-32 left-10 h-72 w-72 rounded-full bg-[#D9A93F]/20 blur-[100px]" />
        <svg className="spin-slow pointer-events-none absolute -right-28 top-1/2 hidden h-[520px] w-[520px] -translate-y-1/2 opacity-20 md:block" viewBox="0 0 200 200" aria-hidden>
          <circle cx="100" cy="100" r="96" fill="none" stroke="#fff" strokeWidth=".4" strokeDasharray="2 4" />
          <circle cx="100" cy="100" r="70" fill="none" stroke="#fff" strokeWidth=".4" />
          <circle cx="100" cy="100" r="44" fill="none" stroke="#8EC0FF" strokeWidth=".6" strokeDasharray="1 3" />
        </svg>
        <div className="relative max-w-2xl">
          <h2 className="font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">{title}</h2>
          <p className="mt-5 text-base leading-relaxed text-slate-300 md:text-lg">{text}</p>
          <div className="mt-9 flex flex-wrap gap-3">
            <Btn to={primary[1]} data-testid="cta-primary-btn">{primary[0]}</Btn>
            <Btn to={secondary[1]} variant="ghostLight" arrow={false} data-testid="cta-secondary-btn">{secondary[0]}</Btn>
          </div>
        </div>
      </Reveal>
    </Container>
  </section>
);
